import roles from "./rolesData";

export default function StudentLifeBodyComponent() {
    return (
        <div>
            {/* Intro */}
            <div className="py-5">
                <div className="container py-3">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 text-center">
                            <h2 className="fw-bold mb-4" style={{ fontSize: "clamp(1.5rem, 3.5vw, 2.25rem)" }}>
                                Pick your role. Own your domain.
                            </h2>
                            <p className="text-muted" style={{ fontSize: "clamp(0.95rem, 1.8vw, 1.1rem)", lineHeight: 1.7 }}>
                                Each role at Extern Academy is a real function of a real company. You'll go deep — not wide — and leave with a track record. Your Startup Trainer is a founder who has raised capital and shipped to real users. They'll push you.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Role Cards */}
            <div className="pb-5">
                <div className="container pb-4">
                    <div className="row g-4">
                        {roles.map((role) => (
                            <div key={role.slug} className="col-12 col-md-6 col-lg-4">
                                <a
                                    href={`/student-life/${role.slug}`}
                                    className="text-decoration-none h-100 d-block"
                                >
                                    <div
                                        className="h-100 rounded-3 p-4 bg-white d-flex flex-column"
                                        style={{ border: "1.5px solid #e5e7eb", transition: "border-color 0.15s" }}
                                        onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#3769B9")}
                                        onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#e5e7eb")}
                                    >
                                        <p
                                            className="fw-semibold text-uppercase mb-1"
                                            style={{ color: "#3769B9", fontSize: "0.72rem", letterSpacing: "0.08em" }}
                                        >
                                            {role.label}
                                        </p>
                                        <h3
                                            className="fw-bold mb-2"
                                            style={{ fontSize: "clamp(1.35rem, 2.5vw, 1.65rem)", color: "#111" }}
                                        >
                                            {role.title}
                                        </h3>
                                        <p
                                            className="fw-semibold mb-3"
                                            style={{ color: "#444", fontSize: "0.9rem" }}
                                        >
                                            {role.tagline}
                                        </p>
                                        <p
                                            className="text-muted flex-grow-1 mb-4"
                                            style={{ fontSize: "0.88rem", lineHeight: 1.65 }}
                                        >
                                            {role.description}
                                        </p>
                                        <span
                                            className="d-inline-flex align-items-center gap-1 fw-semibold"
                                            style={{ color: "#3769B9", fontSize: "0.88rem" }}
                                        >
                                            Learn more{" "}
                                            <span className="material-symbols-outlined" style={{ fontSize: "1rem" }}>
                                                arrow_forward
                                            </span>
                                        </span>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* CTA Banner */}
            <div className="py-5" style={{ backgroundColor: "#3769B9" }}>
                <div className="container text-center text-white py-3">
                    <h2 className="fw-bold mb-3" style={{ fontSize: "clamp(1.4rem, 3vw, 2rem)" }}>
                        Ready to own a role?
                    </h2>
                    <p
                        className="mb-4 mx-auto"
                        style={{ opacity: 0.8, fontSize: "clamp(0.95rem, 1.8vw, 1.1rem)", maxWidth: "440px" }}
                    >
                        Applications are open. Cohorts are small by design — seats go fast.
                    </p>
                    <a
                        href="/apply"
                        className="btn btn-lg btn-danger d-inline-flex align-items-center gap-2"
                    >
                        Apply Now <span className="material-symbols-outlined">arrow_forward</span>
                    </a>
                </div>
            </div>
        </div>
    );
}
